import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=7e7ff97b&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports